import { FormControlProps } from 'baseui/form-control';
import { FormControl as BaseFormControl } from '@tigergraph/app-ui-lib/form-control';
import { mergeOverrides } from 'baseui';
import { Overrides } from 'baseui/overrides';
import { CustomTheme } from '@tigergraph/app-ui-lib/Theme';

export function FormControl({
  overrides,
  error,
  size = 'default',
  ...props
}: FormControlProps & {
  size?: 'compact' | 'default' | 'large';
}) {
  const formControlOverrides =
    size === 'default'
      ? {
          Label: {
            style: ({ $theme }: { $theme: any }) => {
              const theme = $theme as CustomTheme;
              return {
                ...theme.typography.Body1,
                marginTop: '-8px',
                fontWeight: 500,
              };
            },
          },
        }
      : {
          Label: {
            style: ({ $theme }: { $theme: any }) => {
              const theme = $theme as CustomTheme;
              return {
                ...theme.typography.Body2,
                marginTop: '-8px',
                fontWeight: 500,
              };
            },
          },
        };

  return (
    <BaseFormControl
      {...props}
      error={error || undefined}
      overrides={mergeOverrides(formControlOverrides as Overrides<unknown>, overrides as Overrides<unknown>)}
    />
  );
}
